import React, {useEffect, useContext} from 'react';

import {EventMarketingInterface} from "../../../shared/interfaces/marketing/event-marketing.interface";
import {EVENT_MARKETING_TYPE} from 'config/enums';
import {TrackManagementProps} from 'shared/interfaces/marketing/event-marketing-props.interface';
import {TiktokPixelContext} from "../../../context/tracking/declarations";

const TiktokPixelManagement: React.FC<TrackManagementProps> = ({data}) => {
	const {state, setState} = useContext(TiktokPixelContext);

	useEffect(() => () => {
		setState({
			active: false,
			code: '',
			eventAddToCart: false,
			eventInitiateCheckout: false,
			eventAddPaymentInfo: false,
			eventCompleteRegistration: false,
			eventPurchase: false,
		})
	}, [])

	useEffect(() => {
		if (!data) return;
		const pixel = data.find((el: EventMarketingInterface) =>
			el.type === EVENT_MARKETING_TYPE.TIKTOK_PIXEL);
		if (pixel) {
			setPixelValues(pixel);
		}
	}, [data]);

	useEffect(() => {
		if (!state.code) return;
		const script = document.createElement("script");
		const scriptLoaded = document.querySelectorAll<HTMLScriptElement>("[id^='tiktok-pixel-']");
		if (scriptLoaded.length == 0) {
			script.id = `tiktok-pixel-${state.code}`;
			script.async = true;
			script.innerHTML = `
			  !function (w, d, t) {
				w.TiktokAnalyticsObject=t;
				var ttq=w[t]=w[t]||[];
				ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group",
				"enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
				ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0))) }};
				for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
				ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};
				ttq.load=function(e,n){
				  var r="https://analytics.tiktok.com/i18n/pixel/events.js",
					  o=n&&n.partner;
				  ttq._i=ttq._i||{};
				  ttq._i[e]=[];
				  ttq._i[e]._u=r;
				  ttq._t=ttq._t||{};
				  ttq._t[e]=+new Date;
				  ttq._o=ttq._o||{};
				  ttq._o[e]=n||{};
				  n=document.createElement("script");
				  n.type="text/javascript";
				  n.async=!0;
				  n.src=r+"?sdkid="+e+"&lib="+t;
				  e=document.getElementsByTagName("script")[0];
				  e.parentNode.insertBefore(n,e)
				};
			  }(window, document, 'ttq');
    		`;
			document.head.appendChild(script);
			if (window.ttq && state.active) {
				window.ttq.load(state.code, {
					historyObserver: false, autoConfig: false, deduplicate: true, skipAutoStart: true
				});
				window.ttq.page();
			}
		}
	}, [state.code]);


	useEffect(() => {
		return () => {
			removePixelScript();
		}
	}, []);

	const setPixelValues = (pixel: EventMarketingInterface) => {
		setState({
			active: (pixel.status === 'ENABLED'),
			code: pixel.options?.code ?? '',
			eventAddToCart: pixel.options?.addToCart ?? false,
			eventInitiateCheckout: pixel.options?.initiateCheckout ?? false,
			eventAddPaymentInfo: pixel.options?.addPaymentInfo ?? false,
			eventCompleteRegistration: pixel.options?.eventCompleteRegistration ?? false,
			eventPurchase: pixel.options?.purchase ?? false,
		})
	}

	const removePixelScript = () => {
		document.head.querySelectorAll<HTMLScriptElement>("[id^='tiktok-pixel-']")
			.forEach(el => el.remove());
		if (window.ttq) {
			delete (window as any).ttq?._i?.[state.code];
			delete window.ttq;
		}
		setState({
			active: false,
			code: '',
			eventAddToCart: false,
			eventInitiateCheckout: false,
			eventAddPaymentInfo: false,
			eventCompleteRegistration: false,
			eventPurchase: false,
		})
	}

	return (<></>);
}

export default TiktokPixelManagement;
